module.exports = __webpack_public_path__ + "img/mtstart.8cd3a152.png";